"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOccurrences = exports.getNthNumberDayOfTheMonth = exports.isWeekDays = exports.isRecurrenceDateBoundErrorCode = exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE = exports.MAX_OCCURRENCE_LIMIT = void 0;
const luxon_1 = require("luxon");
const enums_1 = require("../enums");
exports.MAX_OCCURRENCE_LIMIT = 366;
const WEEKEND_DAYS = ["Saturday", "Sunday"];
exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE = new Date("2018-01-01T18:00:00.239Z");
const RECURRENCE_DATE_BOUND_ERROR_CODES = [
    "start_date_before_minimum_start_date",
    "end_date_before_minimum_date",
];
const isRecurrenceDateBoundErrorCode = (code) => RECURRENCE_DATE_BOUND_ERROR_CODES.some((boundCode) => boundCode === code);
exports.isRecurrenceDateBoundErrorCode = isRecurrenceDateBoundErrorCode;
const generateDailyOccurrences = ({ recurrence, limit, offsetUtc }) => {
    let currentDate = recurrence.startUtc;
    let isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
    let count = 0;
    const res = [];
    while (!isPastRepeatUntilDate && res.length < limit) {
        if ((offsetUtc && offsetUtc <= currentDate) || !offsetUtc) {
            res.push({
                startUtc: currentDate.toJSDate(),
                endUtc: recurrence.endUtc.plus({ days: count }).toJSDate(),
            });
        }
        currentDate = currentDate.plus({ days: 1 });
        isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
        ++count;
    }
    return res;
};
const isWeekDays = (date) => {
    return !WEEKEND_DAYS.includes(date.toFormat("EEEE"));
};
exports.isWeekDays = isWeekDays;
const generateWeekDaysOccurrences = ({ recurrence, limit, offsetUtc }) => {
    let currentDate = recurrence.startUtc;
    let isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
    let count = 0;
    const res = [];
    while (!isPastRepeatUntilDate && res.length < limit) {
        if (((offsetUtc && offsetUtc <= currentDate) || !offsetUtc) && (0, exports.isWeekDays)(currentDate)) {
            res.push({
                startUtc: currentDate.toJSDate(),
                endUtc: recurrence.endUtc.plus({ days: count }).toJSDate(),
            });
        }
        currentDate = currentDate.plus({ days: 1 });
        isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
        ++count;
    }
    return res;
};
const generateWeeklyOccurrences = ({ recurrence, limit, offsetUtc }) => {
    let currentDate = recurrence.startUtc;
    let isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
    let count = 0;
    const res = [];
    while (!isPastRepeatUntilDate && res.length < limit) {
        if ((offsetUtc && offsetUtc <= currentDate) || !offsetUtc) {
            res.push({
                startUtc: currentDate.toJSDate(),
                endUtc: recurrence.endUtc.plus({ weeks: count }).toJSDate(),
            });
        }
        currentDate = currentDate.plus({ weeks: 1 });
        isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
        ++count;
    }
    return res;
};
const getNthNumberDayOfTheMonth = (date) => {
    const dayNumber = date.day;
    return Math.ceil(dayNumber / 7);
};
exports.getNthNumberDayOfTheMonth = getNthNumberDayOfTheMonth;
/**
 * Generate monthly occurrences. Based on the day of the week, not the day of the month.
 * @example Every second Tuesday of the Month. Read test for more example.
 * @param {Recurrence} recurrence
 * @param {number} limit
 * @param {Date} offsetUtc
 * @returns all occurrences from the recurrence.
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
const generateMonthlyOccurrences = ({ recurrence, limit, offsetUtc }) => {
    let currentDate = recurrence.startUtc;
    const diff = recurrence.endUtc.diff(recurrence.startUtc);
    const nthNumberDayofTheMonth = (0, exports.getNthNumberDayOfTheMonth)(currentDate);
    const res = [];
    let lastAddedDate = null;
    let count = 0;
    let isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
    if (offsetUtc && offsetUtc > currentDate) {
        lastAddedDate = currentDate;
    }
    while (!isPastRepeatUntilDate && res.length < limit) {
        if ((offsetUtc && offsetUtc <= currentDate) || !offsetUtc) {
            if (!lastAddedDate || currentDate.month !== lastAddedDate.month) {
                if (lastAddedDate) {
                    ++count;
                }
                if (!lastAddedDate) {
                    res.push({
                        startUtc: currentDate.toJSDate(),
                        endUtc: currentDate.plus(diff).toJSDate(),
                    });
                    count = 0;
                    lastAddedDate = currentDate;
                }
                else {
                    if (nthNumberDayofTheMonth !== 5 && count === nthNumberDayofTheMonth) {
                        res.push({
                            startUtc: currentDate.toJSDate(),
                            endUtc: currentDate.plus(diff).toJSDate(),
                        });
                        count = 0;
                        lastAddedDate = currentDate;
                    }
                    if (nthNumberDayofTheMonth === 5 && count === 5) {
                        res.push({
                            startUtc: currentDate.toJSDate(),
                            endUtc: currentDate.plus(diff).toJSDate(),
                        });
                        count = 0;
                        lastAddedDate = currentDate;
                    }
                    if (nthNumberDayofTheMonth === 5 && count === 4) {
                        const nextWeek = currentDate.plus({ weeks: 1 });
                        if (nextWeek.month !== currentDate.month) {
                            res.push({
                                startUtc: currentDate.toJSDate(),
                                endUtc: currentDate.plus(diff).toJSDate(),
                            });
                            count = 0;
                            lastAddedDate = currentDate;
                        }
                    }
                }
            }
            currentDate = currentDate.plus({ weeks: 1 });
            isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
        }
        if (offsetUtc && offsetUtc > currentDate) {
            currentDate = currentDate.plus({ weeks: 1 });
            isPastRepeatUntilDate = recurrence.repeatUntilDate ? currentDate > recurrence.repeatUntilDate : false;
        }
    }
    return res;
};
const generateOccurrences = ({ recurrence, limit, offsetUtc, timeZone }) => {
    const recurrenceStartUtc = luxon_1.DateTime.fromJSDate(recurrence.startUtc).setZone(timeZone);
    const recurrenceEndUtc = luxon_1.DateTime.fromJSDate(recurrence.endUtc).setZone(timeZone);
    const recurrenceRepeatUntilDate = recurrence.repeatUntilDate
        ? luxon_1.DateTime.fromJSDate(recurrence.repeatUntilDate).setZone(timeZone)
        : null;
    const offsetUtcDateTime = offsetUtc ? luxon_1.DateTime.fromJSDate(offsetUtc) : undefined;
    if (recurrence.repeatUntilDate && recurrence.repeatUntilDate < recurrence.startUtc) {
        return [];
    }
    const recurrenceDateTime = {
        type: recurrence.type,
        startUtc: recurrenceStartUtc,
        endUtc: recurrenceEndUtc,
        repeatUntilDate: recurrenceRepeatUntilDate,
    };
    switch (recurrence.type) {
        case enums_1.TicketingRecurrenceType.Once:
            return [
                {
                    startUtc: recurrence.startUtc,
                    endUtc: recurrence.endUtc,
                },
            ];
        case enums_1.TicketingRecurrenceType.Daily: {
            // To avoid too much computing with a date too far away from offset.
            if (recurrence.startUtc < exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE) {
                throw new TypeError(`The startUtc should be before ${exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE}`);
            }
            return generateDailyOccurrences({ recurrence: recurrenceDateTime, limit, offsetUtc: offsetUtcDateTime });
        }
        case enums_1.TicketingRecurrenceType.WeekDays: {
            if (recurrence.startUtc < exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE) {
                throw new TypeError(`The startUtc should be before ${exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE}`);
            }
            return generateWeekDaysOccurrences({ recurrence: recurrenceDateTime, limit, offsetUtc: offsetUtcDateTime });
        }
        case enums_1.TicketingRecurrenceType.Weekly: {
            if (recurrence.startUtc < exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE) {
                throw new TypeError(`The startUtc should be before ${exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE}`);
            }
            return generateWeeklyOccurrences({ recurrence: recurrenceDateTime, limit, offsetUtc: offsetUtcDateTime });
        }
        case enums_1.TicketingRecurrenceType.Monthly: {
            if (recurrence.startUtc < exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE) {
                throw new TypeError(`The startUtc should be before ${exports.MINIMUM_START_UTC_DATE_FOR_RECURRENCE}`);
            }
            return generateMonthlyOccurrences({ recurrence: recurrenceDateTime, limit, offsetUtc: offsetUtcDateTime });
        }
        default:
            return [];
    }
};
exports.generateOccurrences = generateOccurrences;
